<template>
    <span class="premium" :class="{'inline' : inline == true, 'block': inline != true}" v-if="$store.getters.getPackage != 'premium'" v-tooltip.top="'Unlock to PREMIUM plan'"><i class="fas fa-lock"  ></i></span>
</template>

<script>
    export default {
        props: {
            'inline' : {
                default: false,
            }
        }
        
    }
</script>

<style lang="scss" scoped>
    .premium{
        border-radius: 50%;
        color: white;
        background: rgb(37, 194, 225);
        padding: 3px 6px 4px 6px;
        font-size: 9px;
        &.inline{
            padding: 3px 6px 5px 6px;
            top: -3px;
            position: relative;
        }
        &.block{
            margin-top: -10px;
            margin-right: -6px;
            position: absolute;
            top: 0;
            right: 0;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/elements/PremiumLock.vue